<template>
  <v-stepper v-model="stage">
    <v-stepper-header>
      <v-stepper-step :complete="stage>1" step="1">
        Επιλέξτε oικονομικές οφειλές για πληρωμή
      </v-stepper-step>
      <v-stepper-step :complete="stage>2" step="2">
        Επίσκοπηση πληρωμής
      </v-stepper-step>
      <v-stepper-step :complete="stage>3" step="3">
        Πληρωμή μέσω κάρτας/paypal/κατάθεση
      </v-stepper-step>
      <v-stepper-step :complete="stage>4" step="4">
        Eπιβεβαίωση
      </v-stepper-step>
    </v-stepper-header>
    <v-stepper-items>
      <v-stepper-content step="1">
        <div class="pl-4 pr-4">
          <h3 v-if="isMobile"> Επιλέξτε Οικονομικές εκκρεμότητες</h3>
        </div>
        <v-data-table id="table" v-if="!isMobile" :headers="headers" :items="selectDepts"
                      :group-by="['PartnerBrandName']"
                      disable-pagination
                      hide-default-footer fixed-header height="70vh"

                      no-data-text="Δεν υπάρχουν οικονομικές εκκρεμότητες"
        >
          <template v-slot:group.header="{items,group}">
            <td colspan="5" class="text-start">
              <v-list-item dense>
                <v-list-item-content>
                  {{ group }}
                </v-list-item-content>

                <v-list-item-action>
                  <v-list-item-action-text> Υπόλοιπο</v-list-item-action-text>
                  <span
                      style="font-size: 1.4em">{{
                      items.map(d => d.Balance).reduce((a, c) => Number(a) + Number(c), 0) - items.filter(d => d.StandBy).map(d => d.Balance).reduce((a, c) => Number(a) + Number(c), 0) | fixed
                    }}‎€ </span>
                </v-list-item-action>
                <v-list-item-action>
                  <v-list-item-action-text> Σε Αναμονή</v-list-item-action-text>
                  <span style="font-size: 1.4em">{{
                      items.filter(d => d.StandBy).map(d => d.Balance).reduce((a, c) => Number(a) + Number(c), 0) | fixed
                    }}‎€ </span>
                </v-list-item-action>
              </v-list-item>
            </td>
          </template>
          <template v-slot:item.NumberPar="{item}">
            <div v-if="item.NumberPar">{{ item.NumberPar }}</div>
            <div v-else>
              <v-chip> Σε αναμονή</v-chip>
            </div>
          </template>
          <template v-slot:item.Balance="{item}">
            <div class="text-center"
                 style=" border:grey 1px solid; font-weight: bold; font-size: 1em;">
              {{ item.Balance | fixed }}‎€
            </div>
          </template>
          <template v-slot:item.Description="{item}">
            {{ item.Description }}
            <br/>
            <span style="color:green;"
                  v-if="item.PendingAmount"> Αναμονή έγκρισης πληρωμής: {{ item.PendingAmount | fixed }} €</span>
          </template>
          <template v-slot:item.DateInvoice="{item}">
            {{ item.DateInvoice | fullDate }}
          </template>
          <template v-slot:item.Selected="{item}">
            <v-checkbox :disabled="(item.Balance - item.PendingAmount ) <= 0.001" v-model="item.Selected"></v-checkbox>
          </template>
        </v-data-table>

        <v-data-iterator
            v-if="isMobile"
            :group-by="['BranchAddress']"
            :items="selectDepts"
            hide-default-footer
            disable-pagination
            no-data-text="Δεν υπάρχουν οικονομικές εκκρεμότητες">
          <template v-slot:default="props">
            <template>
              <v-expansion-panels multiple :value="[0]">
                <v-expansion-panel v-for="group in props.groupedItems">
                  <v-expansion-panel-header class="pa-0">
                    <v-list-item dense>
                      <v-list-item-content>
                        {{ group.name }}
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-list-item-action-text> Yπόλοιπο</v-list-item-action-text>
                        <span
                            style="font-size: 1.2em">{{
                            group.items.map(d => d.Balance).reduce((a, c) => Number(a) + Number(c), 0) - group.items.filter(d => d.StandBy).map(d => d.Balance).reduce((a, c) => Number(a) + Number(c), 0) | fixed
                          }}‎€ </span>
                      </v-list-item-action>
                      <v-list-item-action>
                        <v-list-item-action-text> Αναμονή</v-list-item-action-text>
                        <span
                            style="font-size: 1.2em">{{
                            group.items.filter(d => d.StandBy).map(d => d.Balance).reduce((a, c) => Number(a) + Number(c), 0) |fixed
                          }}‎€ </span>
                      </v-list-item-action>
                    </v-list-item>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content eager class="ma-0 pa-0" style="padding:0">
                    <v-list>
                      <dept-item class="pa-0" v-for="item in group.items" :dept="item">
                        <template v-slot:after>
                          <v-checkbox :disabled="(item.Balance - item.PendingAmount) <= 0 "
                                      v-model="item.Selected"></v-checkbox>
                        </template>
                      </dept-item>
                    </v-list>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </template>
          </template>
        </v-data-iterator>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="previewPayment()">ΕΠΙΣΚΟΠΗΣΗ ΠΛΗΡΩΜΗΣ</v-btn>
        </v-card-actions>
      </v-stepper-content>

      <v-stepper-content step="2">
        <div class="pl-4 pr-4">
          <h3 v-if="isMobile"> Επισκόπηση Πληρωμής</h3>
        </div>
        <v-list>
          <v-list-item v-for="(item,index) in items">
            <v-list-item-action>
              <v-btn icon @click="removeItem(index)">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold"> {{ item.name }}</v-list-item-title>
              {{ item.description }}
            </v-list-item-content>
            <v-list-item-action>
              <span :class="isMobile?'':'display-1'"> {{ item.getValue() | fixed }}‎€ </span>
            </v-list-item-action>
          </v-list-item>
          <v-list-item v-if="!showCustomPayment">
            <v-list-item-content>
              <v-btn outlined @click="showCustomPaymentClick()"> ΠΡΟΣΘΗΚΗ ΑΛΛΟΥ ΠΟΣΟΥ </v-btn>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="showCustomPayment">
            <v-list-item-content>
              <v-form v-model="valid">
                <v-row>
                  <v-col>
                  <v-autocomplete
                      :items="branches"
                      item-text="BranchAddress"
                      v-model="newItem.branchId"
                      item-value="Branch_ID"
                      @change="onBranchSelect()"
                      label="Επιλέξτε Κτήριο"
                  >
                    <template v-slot:item="data">
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ data.item.BranchAddress }}, {{ data.item.BranchDimosName }}
                        </v-list-item-title>
                        <v-list-item-subtitle>
                          {{ data.item.PartnerBrandName }}
                        </v-list-item-subtitle
                        >
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                  </v-col>
                  <v-col lg="6" cols="12">
                    <v-text-field :counter="50" validate-on-blur :rules="rulesName" v-model="newItem.name"
                                  label="Περιγραφή πληρωμής(*)">
                    </v-text-field>
                  </v-col>
                  <v-col lg="3" cols="12">
                    <v-text-field :rules="rulesPrice" type="number" v-model.number="newItem.amount"
                                  label="Ποσό πληρωμής(*)">
                    </v-text-field>
                  </v-col>
                  <v-col lg="3" cols="12" :align="isMobile?'':'end'">
                    <v-btn :disabled="!valid" outlined large @click="addItem()"> ΠΡΟΣΘΗΚΗ ΠΟΣΟΥ</v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>

            </v-list-item-content>
            <v-list-item-action>
              Σύνολο
              <span class="display-1"> {{ total }}‎€ </span>
            </v-list-item-action>
          </v-list-item>

        </v-list>

        <v-card-actions>
          <v-btn color="secondary" @click="backToSelection()">ΠΡΟΗΓΟΥΜΕΝΟ</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" :disabled="items.length === 0 " @click="stage++">ΠΛΗΡΩΜΗ</v-btn>
        </v-card-actions>
      </v-stepper-content>
      <v-stepper-content step="3">
        <v-row>
          <v-col lg="2">
            <v-card>
              <v-card-title> Σύνολο</v-card-title>
              <v-card-text>
                    <span class="display-1">
                      {{ total }}‎€
                    </span>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col lg="6" v-if="userDetails.Allows.AllowPaypalPayments">
            <v-card class="fill-height">
              <v-card-title> Πληρωμή μέσω κάρτας/Paypal</v-card-title>
              <v-card-text>
                <paypal-button :items="items" @onApprove="onPaypalApprove"></paypal-button>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col lg="4">
            <v-card>
              <v-card-title> Κατάθεση σε τράπεζα</v-card-title>
              <v-card-actions v-if="userDetails.Office.Ibans">
                <e-banking-button @onApprove="onEbankingApprove" :items="items"></e-banking-button>
              </v-card-actions>
              <v-card-text v-if="userDetails.Office.Ibans">
                Επικοινωνήστε μαζί μας για οποιαδήποτε απορία και ζήτημα.
              </v-card-text>
              <v-card-text v-else>
                Δεν υπάρχουν διαθέσιμες τράπεζες για κατάθεση,
                Επικοινωνήστε μαζί μας για οποιαδήποτε απορία
              </v-card-text>
              <v-list>
                <v-list-item v-if="userDetails.Office.PhoneNumber" :href="'tel:'+userDetails.Office.PhoneNumber">
                  <v-list-item-action>
                    <v-icon>mdi-phone</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ userDetails.Office.PhoneNumber }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      τηλέφωνο
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item v-if="userDetails.Office.Email">
                  <v-list-item-action>
                    <v-icon>mdi-email</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ userDetails.Office.Email }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      email
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item v-if="userDetails.Office.Address">
                  <v-list-item-action>
                    <v-icon>mdi-map</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ userDetails.Office.Address }}, {{ userDetails.Office.AreaName }},
                      TK:{{ userDetails.Office.PostCode }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      Διεύθυνση
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card>
          </v-col>

        </v-row>
        <v-card-actions>
          <v-btn color="secondary" @click="stage--">ΠΡΟΗΓΟΥΜΕΝΟ</v-btn>
        </v-card-actions>
      </v-stepper-content>
      <v-stepper-content step="4">
        <v-row justify="center">
          <v-col lg="6">
            <v-card raised class="ma-3">
              <v-row>
                <v-col lg="3" align="center" justify="center">
                  <v-icon color="green" size="100">mdi-check</v-icon>
                </v-col>
                <v-col lg="9">
                  <v-card-title>
                    Η πληρωμή πραγματοποιήθηκε!
                  </v-card-title>
                  <v-card-text>
                    Οι οφειλές θα αφαιρεθούν από τον λογαριασμό σας μέσα στις επόμενες μέρες.
                  </v-card-text>
                  <v-card-actions align="center">
                    <v-btn color="secondary" to="/" class="mt-4" dark> ΕΠΙΣΤΡΟΦΗ ΣΤΗΝ ΑΡΧΙΚΗ</v-btn>
                  </v-card-actions>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <v-col lg="6">
            <v-card class="ma-3">
              <v-list v-if="paypalOrderDetails !== null ">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ paypalOrderDetails.id }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      Κωδικός Συναλλαγής
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card>
          </v-col>
        </v-row>
      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>
</template>

<script>
import PaypalButton from "@/views/Financial/components/PaypalButton";
import {mapActions, mapGetters, mapMutations} from "vuex";
import {CartItem, PaymentTypes} from "@/views/Financial/models/CartItem";
import moment from "moment";
import EBankingButton from "@/views/Financial/components/EBankingButton";
import DeptItem from "@/views/Financial/components/DeptItem";
import branches from "@/wl-core/api/sectors/branches";

export default {
  name: "Payments",
  components: {DeptItem, EBankingButton, PaypalButton},
  data: () => ({

    paypalOrderDetails: null,
    selectDepts: [],
    items: [],
    stage: 1,
    valid: false,
    showCustomPayment:false,
    rulesName: [
      v => (!!v) || 'Ο λόγος πληρωμής πρέπει να είναι συμπληρωμένος',
      v => (v.length <= 50) || 'Πρέπει να είναι μέχρι 50 χαρακτήρες'
    ],
    rulesPrice: [
      v => v > 0 || 'Το πόσο πρέπει να είναι μεγαλύτερο του μηδενός'
    ],
    newItem: {
      name: '',
      amount: 0,
      partnerId: null,
      branchId: null,
    },
    headers: [

      {
        text: 'Hμ/νια ',
        value: 'DateInvoice',
        filterable: true,
        width: "100"
      },
      {
        text: '# Παρ.',
        value: 'NumberPar',
        filterable: true,
        width: "50"
      },
      {
        text: 'Περιγραφή',
        value: 'Description',
        filterable: true,
      },

      {
        text: 'Πελάτης',
        value: 'PartnerBrandName',
      },

      {
        text: 'Ποσό',
        value: 'Balance',
        filterable: true,
        width: "100"
      },
      {
        value: 'Selected',
        text: 'Επιλογή',
        filterable: false,
        sortable: false,
        align: 'end',
        width: '50'
      },
    ]
  }),
  watch: {
    openDepts() {
      this.selectDepts = this.openDepts.map(dept => ({...dept, Selected: false}));
    }
  },
  created() {
    this.showLoading();
    this.getPartnerDetails().then(
        () => this.getOpenDepts({}).then(openDepts => {
          this.hideLoading();
        })
    )
  },
  mounted() {
    this.selectDepts = this.openDepts.map(dept => ({...dept, Selected: false}));

  },
  computed: {
    total() {
      return this.items.reduce((acc, item) => {
        return acc + item.getValue();
      }, 0).toFixed(2)
    },
    ...mapGetters([
      'openDepts',
      'userDetails',
      "isMobile",
      "branches"
    ])
  },
  methods: {
    ...mapActions([
      "getOpenDepts",
      "getPartnerDetails",
    ]),

    ...mapMutations([
      "showLoading",
      "setLoadingMessage",
      "hideLoading",
    ]),
    showCustomPaymentClick(){
      this.showCustomPayment = true
    },
    removeItem(index) {
      this.items.splice(index, 1);
    },
    onBranchSelect() {
      const branch = this.branches.find((b) => b.Branch_ID === this.newItem.branchId);
      this.newItem.partnerId = branch.Partner_ID
    },
    addItem() {
      const random = Math.floor(Math.random() * 1000)
      this.items.push(
          new CartItem(
              {
                payment_type: PaymentTypes.CUSTOM,
                id: '__' + random,
                name: this.newItem.name,
                quantity: 1,
                currency: 'EUR',
                value: this.newItem.amount,
                partner_id:this.newItem.partnerId,
                branch_id:this.newItem.branchId,
                description: 'Προστέθηκε από τον χρήστη'
              }
          )
      )
      this.newItem = {name: '', amount: 1}
    },
    backToSelection() {
      this.stage = 1;
      this.items = this.items.filter(item => item.payment_type !== PaymentTypes.DEPTS)
    },
    onEbankingApprove() {
      this.stage = 4
    },
    onPaypalApprove(orderDetails) {
      this.stage = 4;
      this.paypalOrderDetails = orderDetails;

    },
    previewPayment() {
      this.stage = 2;
      this.items = this.selectDepts.filter(dept => dept.Selected).map((dept) => new CartItem(
          {
            cart_id: dept.PartnerMvItm_ID,
            payment_type: PaymentTypes.DEPTS,
            name: dept.Description,
            partner_id: dept.Partner_ID,
            branch_id: dept.Branch_ID,
            quantity: 1,
            currency: 'EUR',
            value: dept.Balance - dept.PendingAmount,
            description: dept.Description + ' - ' + moment(dept.DateInvoice).format('DD/MM/YYYY') + ' #' + (dept.NumberPar ? dept.NumberPar : '') + ' ' + dept.PartnerBrandName
          }
      )).concat(this.items)
    }
  }
}
</script>

<style scoped>

@media screen and (max-width: 700px) {
  .v-stepper__content {
    padding-left: 0;
    padding-right: 0;
  }
}

</style>

